<div class="notificacao-bar-container">
    <div class="notificacao-header">
        <div class="flex-center u-gap-10">
            <span class="material-symbols-outlined u-text-white u-fs-22">notifications</span>
            <h2 class="u-text-white">{{ 'TITLES.ONDETAH_NOTIFICATIONS' | translate }}</h2>
        </div>
        <button (click)="fechar()" class="btn-close">
            <span class="material-symbols-outlined">close</span>
        </button>
    </div>
    <div class="notificacao-content">
        <!-- Lista de notificações -->
        <div *ngIf="listaUnificada.length > 0; else emptyState" class="notifications-list">
            <div *ngFor="let notificacao of listaUnificada" class="notification-card" [@cardAnimation]>
                <div (click)="marcarComoLido(notificacao)"  class="btn-mark-read" title="Marcar como lida">
                    <span class="material-symbols-outlined u-fs-16">close</span>
                </div>
                
                <div class="notification-card-header">

                    <div class="notification-badge new">Novos</div>
                    <span class="notification-time">
                        <i class="material-symbols-outlined">schedule</i>
                        {{ notificacao.dataCadastro | date: 'dd/MM/yyyy HH:mm':'-0300' }}
                    </span>
                </div>

                <div class="notification-card-content">

                    <div *ngIf="notificacao.imagem" class="notification-image">
                        <img [src]="notificacao.imagem" [alt]="notificacao.titulo" />
                    </div>

                    <h3 class="notification-title">{{ notificacao.titulo | translate}}</h3>
                    <p  class="notification-description">{{ notificacao.descricao | translate }}</p>

                    <div *ngIf="notificacao.tipo === 'novidade'" (click)="abrirLink(notificacao)" class="link-novidade">
                        {{'COMMON.READ_MORE' | translate}}
                    </div>

                    <div *ngIf="notificacao.tipo === 'notificacao' && notificacao.link" (click)="abrirLink(notificacao)" class="link-novidade">
                        <i class="material-symbols-outlined">download</i>
                        {{'COMMON.DOWNLOAD' | translate}}
                    </div>
                    <div *ngIf="notificacao.tipo === 'notificacao' && !notificacao.link" (click)="irParaExportacoes()" class="link-novidade-primary">
                        {{'COMMON.GO_EXPORTS' | translate}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Estado vazio -->
        <ng-template #emptyState>
            <div class="empty-state">
                <div class="empty-state-icon">
                    <span class="material-symbols-outlined">notifications_off</span>
                </div>
                <h3 class="empty-state-title">{{'TITLES.NO_NOTIFICATIONS' | translate }}</h3>
                <p class="empty-state-description">{{'SUB_TITLES.NO_NOTIFICATIONS' | translate }}</p>
            </div>
        </ng-template>
    </div>
</div>